import { Check } from 'lucide-react';

import { SectionWrapper } from '../../components/SectionWrapper';
import { facultyControls, facultySteps } from './kaiCoachContent';
import { KaiCoachSectionHead } from './KaiCoachSectionHead';

import styles from './KaiCoachFacultySection.module.css';

export function KaiCoachFacultySection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-faculty-title"
      background="white"
      data-testid="kai-coach-section-faculty"
    >
      <KaiCoachSectionHead
        id="kai-coach-faculty-title"
        kicker="For faculty"
        title={
          <>
            Kudu builds it. You review it. <em>About one to two hours of your time.</em>
          </>
        }
      />
      <ol className={styles.steps}>
        {facultySteps.map((step, index) => (
          <li className={styles.step} key={step.title}>
            <span aria-hidden="true" className={styles.stepNumber}>
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className={styles.stepTitle}>{step.title}</h3>
            <p className={styles.stepBody}>{step.body}</p>
          </li>
        ))}
      </ol>
      <div className={styles.controls}>
        <div>
          <h3 className={styles.controlsTitle}>You stay in control</h3>
          <p className={styles.controlsBody}>
            In a Kudu course, Kai Coach is a module listed with your chapters. It also works in
            courses that don’t use Kudu.
          </p>
        </div>
        <ul className={styles.controlList}>
          {facultyControls.map((control) => (
            <li className={styles.control} key={control}>
              <Check aria-hidden="true" className={styles.check} size={16} />
              {control}
            </li>
          ))}
        </ul>
      </div>
    </SectionWrapper>
  );
}
